import { render, staticRenderFns } from "./ActivityTeamStory.vue?vue&type=template&id=ef4033de&scoped=true&"
import script from "./ActivityTeamStory.vue?vue&type=script&lang=js&"
export * from "./ActivityTeamStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4033de",
  null
  
)

export default component.exports